import React from "react";
import axios from "axios";
import { useParams } from 'react-router-dom';
import { notifications } from '@mantine/notifications';
import { Drawer, Group, Text, ActionIcon, Box, Divider, Button } from '@mantine/core';
import { IconMessageChatbot, IconArrowLeft } from '@tabler/icons-react';

import { useLoginContext } from "../../context/loginContext";

import { utils, BE_API_TWO, role, ROOT_BASE_URL } from "../../utils/globalVariables";
import { safetyDecodeJWT, arrCekDoubleBarangFisik } from "../../utils/globalFunctions";

import { canAccessModifyStepNota } from "../../utils/accessing";

import ImageLightBox2 from "../../components/general/ImageLightBox2";
import ModalTakeAction from "../../components/general/ModalTakeAction";
import ModalResponse from "../../components/general/ModalResponse";

import PaperWrapper from "../../components/utilities/PaperWrapper";
import StepNota from "../../components/utilities/StepNota";
import StepNotaDibatalkan from "../../components/utilities/StepNotaDibatalkan";
import FeedbackDrawer from "../home/feedback/FeedbackDrawer";

const ProjectAntrianSelected = ({
    fnRefreshNotaIndex,
    fnSuccessTakesThisProject,
    fnCloseDrawer,
    stateData
}) => {

    const mountedRef = React.useRef(true);
    const { URI1 } = useParams();

    const notificationId = React.useRef({
        successSubmitData: 'ProjectAntrianSelected-1',
        errorSubmitData: 'ProjectAntrianSelected-2',
    })

    const { loginContext, handleSetLoginContext } = useLoginContext();

    const utilsRef = React.useRef({
        projectProcess: utils.projectProcess.antrian.value,
        projectIsCancel: '0',
        userAccess: [
            // role.owner.subLevel.owner.slugSubLevel,
            // role.admin.subLevel.admin_kepala.slugSubLevel,
            // role.admin.subLevel.admin_staf.slugSubLevel,
        ]
    })

    const [data, setData] = React.useState({
        imageLightboxImages: '',
        imageLightboxTitle: '',
        imageLightboxIndex: '',
        imageLightboxFieldName: '',
        imageLightboxShow: false,

        feedbackModal: false,

        submitConfirmationModal: false,
        submitLoading: false,

        modalResponse: {
            show: false,
            type: utils.modalResponse.warning,
            hideOnClickOutSide: false,
            content: ''
        }
    });

    React.useEffect(() => {
        return () => {
            // mountedRef.current = false;
        }
    }, [])

    const mulaiKerjakanProject = () => {
        setData(d => ({ ...d, submitLoading: true }))

        const formDT = new FormData();
        const formDTHeader = { 'Content-Type': 'application/json' }

        formDT.append('json_token', loginContext.syswebapp);
        formDT.append('project_id', URI1);
        formDT.append('project_process_antrian', utils.projectProcess.antrian.value);
        formDT.append('project_process_pengerjaan', utils.projectProcess.pengerjaan.value);
        formDT.append('project_pengerjaan_progress', JSON.stringify(utils.pengerjaanProgress.mulai_dikerjakan));
        formDT.append('project_is_cancel', '0');
        formDT.append('arr_cek_double_barang_fisik', JSON.stringify(arrCekDoubleBarangFisik()));

        axios({
            method: 'post',
            url: BE_API_TWO + '/mulai_kerjakan_project',
            data: formDT,
            headers: formDTHeader,
        }).then((response) => {
            if (!mountedRef.current) return null;

            setData(d => ({ ...d, submitLoading: false, submitConfirmationModal: false }));

            if (response.data.flag_status === 'isset') {
                fnCloseDrawer();

                notifications.show({
                    id: notificationId.current.successSubmitData,
                    title: utils.notification.success.caption,
                    message: 'Berhasil Submit Data',
                    color: utils.notification.success.color,
                    icon: utils.notification.success.icon,
                    withBorder: true,
                    autoClose: true,
                })

                fnSuccessTakesThisProject();
            }

            if (response.data.flag_status === 'error') {
                notifications.show({
                    id: notificationId.current.errorSubmitData,
                    title: utils.notification.warning.caption,
                    message: response.data.pesan,
                    color: utils.notification.warning.color,
                    icon: utils.notification.warning.icon,
                    withBorder: true,
                    autoClose: true,
                })
            }

            if (response.data.flag_status === 'double-barang-fisik') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Barang ini sedang dalam proses service dan belum dilakukan pengambilan.',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'belum-ada-teknisi-rekomendasi') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Tentukan teknisi terlebih dahulu.',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'bukan-teknisi-rekomendasi') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Anda tidak dapat mengerjakan project ini.',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'no-data') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: 'Data tidak ditemukan.',
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'not-complete-data') {
                setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        type: utils.modalResponse.warning,
                        hideOnClickOutSide: true,
                        content: response.data.message,
                        show: true
                    }
                }))
            }

            if (response.data.flag_status === 'invalid-json-token') {
                handleSetLoginContext(null);
            }

            if (response.data.flag_status === 'user-inactive') {
                handleSetLoginContext(null);
            }
        }).catch(error => {
            if (!mountedRef.current) return null;

            setData(d => ({
                ...d,
                submitLoading: false,
                submitConfirmationModal: false
            }))

            notifications.show({
                id: notificationId.current.errorSubmitData,
                title: utils.notification.warning.caption,
                message: error.message,
                color: utils.notification.warning.color,
                icon: utils.notification.warning.icon,
                withBorder: true,
                autoClose: true,
            })
        })
    }

    return (
        <React.Fragment>
            <Drawer
                opened={URI1}
                onClose={fnCloseDrawer}
                withCloseButton={false}
                position="left"
                closeOnClickOutside={true}
                title={
                    <Group noWrap spacing='xs'>
                        <ActionIcon
                            size='lg'
                            variant="light"
                            radius='xl'
                            color="blue"
                            onClick={fnCloseDrawer}
                        >
                            <IconArrowLeft size='1.25rem' stroke={1.5} />
                        </ActionIcon>

                        <Group position='apart' style={{ width: '100%' }}>
                            <Text>Antrian</Text>
                            <ActionIcon
                                size='lg'
                                variant="light"
                                color="green"
                                radius='xl'
                                onClick={() => setData(d => ({ ...d, feedbackModal: true }))}
                            >
                                <IconMessageChatbot size='1.25rem' stroke={1.25} />
                            </ActionIcon>
                        </Group>
                    </Group>
                }
                size='md'

                styles={() => ({
                    title: {
                        fontWeight: 'bold',
                        textTransform: 'uppercase',
                        width: '100%',
                    }
                })}
            >
                {canAccessModifyStepNota({ stateObject: { subLevel: loginContext } }) ?
                    <StepNota
                        stateURI1={URI1}
                        stateUtilsRef={utilsRef.current}
                        stateIsSequence={true}

                        fnRefreshNotaIndex={fnRefreshNotaIndex}

                        fnRefreshHistory={() => { }}

                        fnRefreshStepSelesai={() => { }}

                        fnClickPhoto={(object) => setData(d => ({
                            ...d,
                            imageLightboxImages: object.images,
                            imageLightboxTitle: object.title,
                            imageLightboxIndex: object.index,
                            imageLightboxFieldName: object.fieldName,
                            imageLightboxShow: true,
                        }))}

                        stateShowMediaQC={false}
                        fnClickMediaImageVideo={() => { }}

                        fnCloseDrawer={fnCloseDrawer}
                    />
                    :
                    <StepNotaDibatalkan
                        stateURI1={URI1}
                        stateUtilsRef={utilsRef.current}

                        fnRefreshNotaIndex={fnRefreshNotaIndex}

                        fnRefreshHistory={() => { }}

                        fnClickPhoto={(object) => setData(d => ({
                            ...d,
                            imageLightboxImages: object.images,
                            imageLightboxTitle: object.title,
                            imageLightboxIndex: object.index,
                            imageLightboxFieldName: object.fieldName,
                            imageLightboxShow: true,
                        }))}

                        stateShowMediaQC={false}
                        fnClickMediaImageVideo={() => { }}

                        fnCloseDrawer={fnCloseDrawer}
                    />
                }

                {[role.owner.slugLevel, role.teknisi.slugLevel].includes(safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappl')) &&
                    <Box mb='xl' mt='1rem'>
                        <PaperWrapper>
                            <Text size='sm' fw='bold'>
                                {safetyDecodeJWT(loginContext, 'syswebapp', 'syswebappn')},
                            </Text>

                            <Text size='sm' mb='xs' color="dimmed">
                                Siap mulai mengerjakan project ini ?
                            </Text>

                            <Divider />

                            <Text size='sm' my='xs' color="dimmed">
                                Setelah klik Mulai Kerjakan, project ini akan berlanjut ke proses Pengerjaan.
                            </Text>

                            <Button
                                fullWidth
                                loading={data.submitLoading}
                                onClick={() => {
                                    setData(d => ({ ...d, submitConfirmationModal: true }));
                                }}
                            >
                                Ya, Mulai Kerjakan
                            </Button>
                        </PaperWrapper>
                    </Box>
                }
            </Drawer>

            <ImageLightBox2
                stateImages={Array.isArray(data.imageLightboxImages) && (data.imageLightboxImages.length > 0) ? data.imageLightboxImages.map(key => ROOT_BASE_URL + key[data.imageLightboxFieldName]) : []}

                stateTitle={data.imageLightboxTitle}
                stateSelectedIndex={data.imageLightboxIndex}
                stateShow={data.imageLightboxShow}
                fnShow={() => setData(d => ({ ...d, imageLightboxShow: false }))}
            />

            <FeedbackDrawer
                stateShow={data.feedbackModal}
                fnShow={(val) => setData(d => ({ ...d, feedbackModal: val }))}
                stateData={{
                    data: stateData.data,
                }}
                fnShouldUpdateIndex={fnRefreshNotaIndex}
            />

            <ModalTakeAction
                stateShow={data.submitConfirmationModal}
                fnHide={() => setData(d => ({ ...d, submitConfirmationModal: false }))}

                stateHideOnClickOutSide={true}
                stateTitle={String('Confirmation').toUpperCase()}
                stateOverlayZIndex={201}

                stateButtonClosePx='md'

                stateButtonActionCaption='Siap, Kerjakan'
                stateButtonActionPx='xs'
                stateButtonActionColor=""
                stateButtonActionLoading={data.submitLoading}
                fnButtonAction={mulaiKerjakanProject}
            >
                <Text size='sm'>Mulai kerjakan project ini ?</Text>
            </ModalTakeAction>

            <ModalResponse
                stateShow={data.modalResponse.show}
                fnHide={() => setData(d => ({
                    ...d,
                    modalResponse: {
                        ...d.modalResponse,
                        show: false
                    }
                }))}

                stateHideOnClickOutSide={data.modalResponse.hideOnClickOutSide}
                stateType={data.modalResponse.type}
                stateContent={data.modalResponse.content}
            />
        </React.Fragment>
    )
}

export default React.memo(ProjectAntrianSelected);